import { useEffect } from "react";
import environment from "../environments/environment.json";

const useVerisoulScript = () => {
  useEffect(() => {
    const domain = window.location.hostname;

    // Map your domains to project IDs
    const projectMap = {
      localhost: "06b4c7e6-f3a5-4712-97cb-c85f078909ec",
      "127.0.0.1": "691b6b95-3866-4c31-a7fe-8ed5c74b4ccf",
    };

    const projectId =  `${environment.VERISOUL_PROJECT}`;

    const script = document.createElement("script");
    script.src = `https://js.verisoul.ai/${environment.VERISOUL_ENVIRONMENT}/bundle.js`;
    script.async = false;
    script.setAttribute("verisoul-project-id", projectId);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};

export default useVerisoulScript;
